export const screenBreakpoints = {
  lg: 1024,
};
